<template>
    <div>
        <navbar></navbar>
        <div class="container">
            <p class="__portpnew">Building Tracka — How Findworka Empowered Nigerian Citizens to Hold Government Projects Accountable</p>
            <p class="__portp2new">Findworka partnered with BudgIT to create Tracka, the civic-tech platform that lets everyday Nigerians discover, monitor, and report 15 k + public projects in their communities.</p>
            <p class="__meetdname"><span class="__namp">Client Name:</span> BudgIT Nigeria</p>
            <p class="__meetdname"><span class="__namp">Product:</span> Tracka – Civic Engagement & Project-Tracking Platform</p>
            <p class="__meetdname"><span class="__namp">Scope:</span> Web + mobile, geolocation, reporting & admin dashboard.</p>
            <p class="__meetdname"><i>In a country where thousands of government projects are announced every year, Tracka bridges the gap between promises and delivery by giving citizens a voice and officials real-time feedback.</i></p>
            
            <p class="__headin">The Challenge</p>
            <p class="__meetdname"><span class="__namp">Accountability Gaps in Public Spending</span></p>
            <ul class="__portp2new">
                <li>Citizens were often unaware of projects allocated to their communities.</li>
                <li>Many projects were poorly executed or completely abandoned.</li>
                <li>There was no seamless feedback loop between citizens and government officials.</li>
            </ul>
            <p class="__meetdname">BudgIT envisioned a scalable digital tool that could empower Nigerians to track, report and escalate issues on any public project nationwide. They turned to Findworka to make it real.</p>
            
            <p class="__headin">The Solution — Tech with Transparency at Its Core</p>
            <p class="__meetdname">We engineered a platform that puts citizens in the driver’s seat:</p>
            <ul class="__portp2new">
                <li><b class="__namp">Search & View Projects</b> in any LGA</li>
                <li><b class="__namp">Upload Photos, Reviews & Status Updates</b> from project sites</li>
                <li><b class="__namp">Get Alerts</b> about new projects and flagged issues</li>
                <li><b class="__namp">Collaborate & Comment</b> with other community members</li>
                <li><b class="__namp">Escalate</b>  stalled projects to the right authorities</li>
            </ul>
            
            <img src="../assets/img/trackalanding.png" class="__climgr"/>
            <p class="__headin">Key Build Highlights</p>
            <ul class="__portp2new">
                <li><b class="__namp">Geolocation Features –</b> auto-tags updates by community.</li>
                <li><b class="__namp">Mobile-First Experience – </b> designed for users whose only device is a phone.</li>
                <li><b class="__namp">Custom Reporting System –</b> timelines, photos, note fields.</li>
                <li><b class="__namp">Admin Dashboard for BudgIT –</b> verify flags, generate reports, push notifications.</li>
                <li><b class="__namp">Clean, Accessible UX –</b>  intuitive even for non-tech-savvy citizens.</li>
            </ul>

            <p class="__headin">Key Features</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftgeolocation.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">Geotagged Project Updates</span></p>
                        <p class="__meetdname">Auto-location & community tagging</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftphoto.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">Mobile-First Reporting</span></p>
                        <p class="__meetdname">Upload photos & status in seconds</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftreport.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">Admin Analytics Dashboard</span></p>
                        <p class="__meetdname">Verify, flag, and generate oversight reports</p>
                    </div>
                </div>
            </div>

            <p class="__headin">Client Testimonial</p>
            <p class="__meetdname">“Tech doesn’t just solve problems; it gives people a voice. With Tracka, citizens don’t just complain—they take pictures, update progress and raise flags.” <span class="__namp"><i>— BudgIT Community Team</i></span></p>

            <p class="__headin">Results / Impact Tiles</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Public Projects Monitored</span></p>
                        <p class="__meetdname">5,000 +</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Community Feedback Reports</span></p>
                        <p class="__meetdname">7,000 +</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Stalled Projects Revived</span></p>
                        <p class="__meetdname">Countless across multiple states</p>
                    </div>
                </div>
            </div><br>
            <p class="__meetdname">Tracka is now trusted by civil-society organisations, journalists, local authorities, and thousands of engaged citizens.</p>
            <p class="__meetdname">At Findworka we build tools that empower. Tracka has turned passive citizens into active watchdogs, lighting a path to greater accountability and better governance nationwide.</p>

            

            <div class="text-center">
                <p class="__hvsip">Have an idea to ship? Let’s build it—fast.</p>
                <p class="__meetdname">Tell us about your product vision and get a scoped build plan within 48 hours.</p>
                <router-link to="/build" class="btn __viewsite">Get Started Here </router-link>
            </div>
            <div class="__whitespace"></div>
        </div>
    </div>
</template>


<script>
import navbar from '../components/navbar';

export default {
    components: { navbar },
    data(){
        return{}
    },
}
</script>

<style scoped>
@import '../assets/css/portfolio';
</style>


// WEBPACK FOOTER //
// src/components/tracka.vue